import {ActionIcon, Group, TextInput, Transition} from "@mantine/core";
import {IconSearch, IconX} from "@tabler/icons-react";
import React, {useEffect, useState} from "react";
import TableAttributeModel from "../Table/TableAttributeModel";
import {useSearchParams} from "react-router-dom";

export default function SearchBox({searchAttribute}: { searchAttribute: TableAttributeModel; }) {

    const [searchParams, setSearchParams] = useSearchParams();
    const [searchText, setSearchText] = useState(searchParams.get(searchAttribute.name) ?? undefined);

    useEffect(() => {
        setSearchText(searchParams.get(searchAttribute.name) ?? undefined);
    }, [searchParams]);

    return (
        <Group gap={4}>
            <TextInput placeholder={searchAttribute.label}
                       value={searchText ?? ""}
                       onChange={(event) => setSearchText(event.currentTarget.value)}
                       rightSection={
                           <ActionIcon disabled={(searchText?.length ?? 0) === 0}
                                       onClick={() => setSearchParams({[searchAttribute.name]: searchText!})}>
                               <IconSearch style={{width: 16, height: 16}}/>
                           </ActionIcon>
                       }
            />
            <Transition
                mounted={(searchParams.get(searchAttribute.name)?.length ?? 0) > 0}>
                {(styles) => <div style={styles}>
                    <ActionIcon size={"lg"} variant={"light"} onClick={() => {
                        setSearchText(undefined);
                        setSearchParams({});
                    }}>
                        <IconX style={{width: 16, height: 16}}/>
                    </ActionIcon>
                </div>}
            </Transition>
        </Group>
    )
}
